import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import styles from './UnorderedListCell.css';
const UnorderedListCell = ({ elements, }) => (_jsx("ul", Object.assign({ className: styles.list }, { children: elements === null || elements === void 0 ? void 0 : elements.map((el) => (_jsx("li", { children: el }, `unorderedListCell-${el}-${uuidv4()}`))) }), void 0));
export default memo(UnorderedListCell);
